import { render, staticRenderFns } from "./UninstallConfirmation.vue?vue&type=template&id=a7d9fbb2&"
import script from "./UninstallConfirmation.vue?vue&type=script&lang=js&"
export * from "./UninstallConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports